import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {container} from "@Container";
import {TYPES} from "@Types";
import BookSectionNewForm from './book-section-new-form.component';
import { BookSectionAction } from '@Redux/actions/publication/book-section.action';
import { BookSectionCreateParams } from '@Components/publication/book-section-new/validate';

const BookSectionNew: React.FC<CreatearsenalUnitProps> = ({
                                                               datas,
                                                               handleSubmit
                                                             }) => {
  return (
      <div className="mt-2 mb-2">
        <BookSectionNewForm onSubmit={handleSubmit} canSubmit={datas.canSubmit} sections={datas.sections}/>
      </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  datas: {
    canSubmit: true,
    sections: [],
  }
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<BookSectionAction>(TYPES.Actions.Publication.BookSectionAction);

  return {
    handleSubmit: (values: BookSectionCreateParams) => dispatch(action.create(values)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BookSectionNew);

type CreatearsenalUnitProps = ReturnType<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>
